import { createElement } from 'react';
export var m = (function (type) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var vnode = createElement.apply(void 0, [type].concat(args));
    if (typeof vnode.props.class === 'function')
        vnode.props.class = String(vnode.props.class);
    return vnode;
});
